module.exports = "<main class=\"well well--2x error-container\">\n  <div class=\"typ typ--hdg1\">Error</div>\n  <div class=\"vr vr--2x\"></div>\n  <div class=\"typ typ--breathable ut-error-message\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/error/error.html
// module id = 409
// module chunks = 0